<template>
    <div>
        <div class="accordion-container" :class="isClosed ? '' : 'show-less'">
            <div class="accordion-header" @click="handleClosed">
                <img src="/images/new_branding/pack-garantie.png" class="gift-icon">
                <div>
                    <h2 class="pack-pretitle">Garantie satisfaction</h2>
                    <h3 class="pack-title">2€ seulement .
                        Facile à résilier</h3>
                </div>
                <span :class="['accordion-btn', 'show-more', { 'is-open': !isClosed }]"></span>
            </div>
        </div>
        <div class="form-pack">
            <div :class="isClosed ? 'is-closed' : ''" class="accordion-body">
                <div class="pack-iban">
                    <p>Chez Testachats, pas question de vous garder lié à un abonnement contre votre volonté. Grâce à notre garantie de satisfaction, vous êtes libre de mettre fin à votre affiliation quand vous le souhaitez. Il vous suffira de nous en avertir au plus tard 15 jours ouvrables avant chaque échéance mensuelle de votre abonnement*.</p>
                    <p>Il n'y a donc pas d'obligation d'achat définitif puisque vous pouvez annuler votre abonnement à votre gré sans devoir nous fournir la moindre explication.</p>
                    <p>*Attention: tout mois entamé est considéré comme un mois entier.</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import image_mixin from "./mixins/image_mixin";

export default {
    name: "PackComponentAccordionIban",
    mixins: [
        image_mixin
    ],
    computed: {
        isIban() {
            return this.$store.get('general_data/current_step') === 'iban'
        }
    },
    data() {
        return {
            isClosed: true,
        };
    },
    methods: {
        handleClosed() {
            this.isClosed = !this.isClosed;
        },
    },
    mounted() {
        // console.log('test store',(this.$store.get('general_data/current_step' === 'iban')))

    }
}
</script>

<style lang="scss" scoped>

</style>
